module.exports = __webpack_public_path__ + "e0ec1b4e820fd8e73b09b83eb29d5de4.svg";